import { CC, TO } from "country-region-data";

export default {
  SALES_ORDERS_LIST: "Liste des soumissions",
  ADD_SALES_ORDER: "Ajouter une soumission",
  ADD_SALES_ORDER_ITEM: "Ajouter une ligne",
  SALES_ORDER_ADDED: "Soumission ajoutée",
  OWNER: "Propriétaire",
  EDIT_SALES_ORDER: "Modifier une soumission",
  SALES_ORDER_UPDATED: "Soumission mise à jour",
  BILLING_ADDRESS: "Adresse de facturation",
  EXPIRATION_TIME: "Date d'expiration",
  ITEM_TYPE: "Type",
  SELECT_PRODUCTS: "Choisir un produit",
  SELECT_SUBSCRIPTIONS: "Choisir une inscription",
  SELECT_PACKAGES: "Choisir un forfait",
  DELETE_SALES_ORDER_ITEM: "Supprimer la ligne",
  UPDATE_SALES_ORDER_ITEM: "Modifier la ligne",
  SALES_ORDER_ITEM_DELETED: "Ligne supprimée",
  SALES_ORDER_ITEM_ADDED: "Ligne ajoutée",
  SALES_ORDER_ITEM_EDITED: "Ligne modifiée",
  SEND: "Envoyer",
  CANCEL: "Annuler",
  REFUND: "Rembourser",
  ADD_PAYMENT: "Ajouter un paiement",
  SALES_ORDER_SENT: "Soumission envoyée",
  SELECT_USERS: "Choisir l'utilisateur",
  SELECT_CUSTOMERS: "Choisir le client",
  SELECT_ORGANIZATIONS: "Choisir l'organisation",
  SELECT_SUPPLIERS: "Choisir le fournisseur",
  DELETE_THIS_SALES_ORDER: "Supprimer cette soumission ?",
  SALES_ORDER_DELETED: "Soumission supprimée",
  CANCEL_SALES_ORDER_QUESTION: "Annuler la soumission ?",
  SALES_ORDER_CANCELED: "Soumission Annulée",
  RECIPIENT: "Destinataire",
  ISSUER: "Émetteur",
  VALIDATE: "Valider",
  SALES_ORDER_VALIDATED: "Soumission validée",
  GENERATE_INVOICE: "Créer la facture",
  GENERATE_AND_SEND_INVOICE: "Générer et envoyer la facture",
  RESEND_INVOICE: "Renvoyer la facture",
  INVOICING_DATE: "Date de facturation",
  INVOICING_DATE_FALLBACK_WARNING: "Date d'événement manquante — veuillez corriger la soumission avant d'envoyer.",
  CONFIRM_RESEND_INVOICE: "Cette facture a déjà été envoyée. Voulez-vous la renvoyer ?",
  SUBSIDIZED_INVOICE_SENT: "Facture envoyée avec succès",
  SUBSIDIZED_INVOICE_SENT_WITH_NUMBER: "Facture {number} envoyée avec succès",
  INVOICE_NUMBER_PLACEHOLDER_HINT:
    "La facture n'est pas encore créée : son numéro sera attribué à l'envoi et remplacera automatiquement {token} dans l'objet et le message.",
  INVOICE_NUMBER_PLACEHOLDER_REMOVED:
    "Le jeton {token} a été retiré de l'objet et du message : le numéro de facture n'y apparaîtra pas (il reste inscrit sur le PDF joint).",
  WARNINGS: {
    MULTIPLE_INVOICES_EXIST: "Plusieurs factures existent déjà pour cette commande. La plus récente a été utilisée — vérifiez la facturation.",
    REUSING_NON_COMPLETE_INVOICE: "Une facture partielle a été réutilisée au lieu d'en créer une nouvelle.",
    INVOICING_DATE_IGNORED: "La date de facturation fournie a été ignorée : une facture existait déjà avec sa propre date.",
    STAMP_FAILED_AFTER_SEND: "Facture envoyée, mais la trace d'envoi n'a pas pu être enregistrée. Contactez un administrateur avant de renvoyer pour éviter un double envoi.",
    PREVIOUS_INVOICE_WAS_CANCELED: "Une facture précédente avait été annulée. Une nouvelle facture a été générée.",
    PREVIOUS_INVOICE_WAS_DRAFT: "Une facture précédente était restée à l'état brouillon. Une nouvelle facture a été générée.",
  },
  INVOICE_GENERATED: "Facture créée",
  VIEW_INVOICE: "Voir la facture",
  ADD_DELIVERY: "Ajouter une livraison",
  DELIVERIES_STATE: "État de livraison",
  DELIVERIES_STATE_ITEM: "Produit",
  DELIVERIES_STATE_ORDERED_QUANTITY: "Quantité commandée",
  DELIVERIES_STATE_DELIVERED_QUANTITY: "Quantité livrée",
  DELIVERIES_STATE_REMAINING_QUANTITY: "Quantité restante",
  NOT_INVOICED: "À facturer",
  NOT_DELIVERED: "À livrer",
  DELIVERED: "Livré",
  SALES_INVOICES: "Factures vente",
  ADD_INVOICE: "Ajouter une facture",
  INVOICING_TYPE: "Type de facturation",
  INVOICING_TYPE_COMPLETE: "Complète",
  INVOICING_TYPE_AMOUNT: "Montant",
  INVOICING_TYPE_PRODUCT: "Produit",
  INVOICING_STATUS_PENDING: "Non Facturée",
  INVOICING_STATUS_PARTIALLY_INVOICED: "Partiellement facturée",
  INVOICING_STATUS_INVOICED: "Facturée",
  DELIVERY_STATUS_PENDING: "Non Livrée",
  DELIVERY_STATUS_PARTIALLY_DELIVERED: "Partiellement livrée",
  DELIVERY_STATUS_DELIVERED: "Livrée",
  INVOICING_STATUS: "Statut de facturation",
  ORDER_STATUS_DRAFT: "Brouillon",
  ORDER_STATUS_CANCELED: "Annulée",
  ORDER_STATUS_VALIDATED: "Validée",
  ORDER_STATUS_COMPLETED: "Complétée",
  DELIVERY_STATUS: "Statut de livraison",
  INVOICE_TYPE: "Type de facture",
  INVOICE_TYPE_DOWNPAYMENT: "Facture d'acompte",
  INVOICE_TYPE_STANDARD: "Facture standard",
  SALES_ORDER_INVOICE_ADDED: "Facture ajoutée",
  SALES_ORDER_DELIVERY_ADDED: "Livraison ajoutée",
  EVENT_DATE: "Date de l’évènement",
  EVENT_TIME: "Heure de l’évènement",
  DELIVERY_LOCATION: "Local où livrer le traiteur",
  SHOW_SALES_ORDER: "Voir la soumission",
  SALES_ORDER_DESCRIPTION: "Description de la soumission",
  DOWNLOAD_PDF: "Télécharger le pdf",
  PRODUCT_SERVCIE: "Produits/Services",
  QTY: "Qté",
  OWED_AMOUNT: "SOLDE DÛ",
  VALIDATION: "Validation",
  VALIDATION_MESSAGE: "Validez votre soumission maintenant ! Vous trouverez sur cette page tous les détails de votre soumission. Vérifiez correctement les informations",
  COMMENT: "Commentaire",
  ACCEPT_TERMS_AND_CONDITIONS: "Accepter les termes et conditions de soumission",
  ACCEPT: "Accepter",
  REFUSE: "Refuser",
  SALES_ORDER_VALIDATED: "La soumission a bien été validée. Nous vous recontacterons bientôt. Merci.",
  SALES_ORDER_VALIDATED_BO: "La soumission a bien été validée",
  SEND_NOW_QUESTION: "Envoyer la soumission maintenant ?",
  SEND_NOW_HINT: "Vous pouvez envoyer la soumission au client dès maintenant pour éviter les oublis.",
  // SALES_ORDER_CANCELED: "La soumission à bien été Refusé. Nous vous recontacterons bientôt. Merci.",
  ALERT_VALIDATE: "Voulez-vous vraiment <span>ACCEPTER</span> cette soumission ?",
  ALERT_CANCEL: "Voulez-vous vraiment <span>REFUSER</span> cette soumission ?",
  ACCEPT_VALIDATE: "Oui, accepter",
  ACCEPT_CANCEL: "Oui, refuser",
  CLIENT_VALIDATION: "Validation client",
  CLIENT_VALIDATED_STATUS_0: "",
  CLIENT_VALIDATED_STATUS_DRAFT: "Brouillon",
  CLIENT_VALIDATED_STATUS_PENDING: "En attente",
  CLIENT_VALIDATED_STATUS_PENDING_REVISION: "En attente d'acceptation des révisions",
  CLIENT_VALIDATED_STATUS_CANCELED: "Refusée",
  CLIENT_VALIDATED_STATUS_VALIDATED: "Acceptée",
  CLIENT_VALIDATED_STATUS_NOT_REQUIRED: "Non requis",
  VALIDATED_AT: "Acceptée le ",
  CANCELED_AT: "Refusée le ",
  REVERT_TO_DRAFT: "Remettre en brouillon",
  CONFIRM_REVERT_TO_DRAFT: "Êtes-vous sûr de vouloir remettre en brouillon",
  SALES_ORDER_REVERTED: "Soumission remise en brouillon",
  EVENT_NAME: "Nom de l’évènement",
  // Discount-related strings
  ADD_DISCOUNT: "Ajouter une remise",
  EDIT_DISCOUNT: "Modifier la remise",
  DISCOUNT: "Remise",
  DISCOUNT_TYPE: "Type de remise",
  DISCOUNT_PERCENTAGE: "Remise en pourcentage",
  DISCOUNT_AMOUNT: "Remise en montant",
  PERCENTAGE: "Pourcentage",
  FIXED_AMOUNT: "Montant fixe",
  PREVIEW: "Aperçu",
  DISCOUNT_PERCENTAGE_PREVIEW: "Remise de {percentage}% = {amount}",
  DISCOUNT_AMOUNT_PREVIEW: "Remise de {amount}",
  CONFIRM_DELETE_DISCOUNT: "Êtes-vous sûr de vouloir supprimer cette remise ?",
  DISCOUNT_DELETED: "Remise supprimée",
  DISCOUNT_UPDATED: "Remise mise à jour",
  DISCOUNT_ADDED: "Remise ajoutée",
  DISCOUNTS: "Remises",
  THE: "le ",
  ALLERGIES_AND_FOOD_INTOLERANCES: "Allergies et intolérances alimentaires",
  PURCHASE_ORDER_NUMBER: "Numéro de bon de commande",
  SENT_BY: "Envoyé par",
  SENT_TO: "Envoyé à",
  TO: "À",
  CC: "CC",
  BCC: "CCI",
  SENT_AT: "Envoyé le",
  FIRST_SENT_AT: "Premier envoi le",
  CLIENT_REMINDERS: "Rappels au client",
  SENDING_HISTORY: "Historique des envois",
  SENDING_BY: "par {name}",
  SENDING_TYPE_FIRST_SENT: "Premier envoi",
  SENDING_TYPE_RESENT: "Renvoi",
  SENDING_TYPE_REVISION_SENT: "Envoi de la révision",
  SENDING_TYPE_REMINDER: "Rappel automatique",
  SENDING_TYPE_REVERTED_TO_DRAFT: "Remise en brouillon",
  FIRST_SENT_ON: "1er envoi : {date}",
  LAST_REMINDER_ON: "Rappel : {date}",
  IS_SUBSIDIZED: "Soumission aide alimentaire",
  PRICING_TYPE: "Type de prix",
  PRICING_TYPE_STANDARD: "Standard",
  PRICING_TYPE_SUBSIDIZED: "Aide alimentaire",
  PRICING_TYPE_CATERER: "Traiteur",
  PRICING_TYPE_COUPONS: "Coupons (À facturer)",
  ADD_COUPONS_SALES_ORDER: "Soumission de coupons",
  COUPONS_ITEM_NAME: "Nom de l'item à facturer",
  COUPONS_BILLING_PERIOD: "Période de facturation",
  COUPONS_AMOUNT: "Montant à facturer",
  COUPONS_REMAINING_HINT: "Reste à facturer pour cet établissement : {amount}",
  COUPONS_ITEM_DESCRIPTION: "Coupons à facturer pour la période du {start} au {end}",
  COUPONS_SALES_ORDER_ADDED: "Soumission de coupons créée"
};
